<div class="toolbar">
  <p-button
    [label]="'WEB_RESULTS.CENTERS.NEW' | translate"
    icon="pi pi-plus"
    (click)="newRecord()"
  ></p-button>
  <p-button
    label="Eliminar seleccionados"
    severity="danger"
    (click)="deleteSelected()"
    *ngIf="selectedRecords?.length"
  ></p-button>
</div>

<p-table
  [value]="records$ | async"
  styleClass="p-datatable-striped"
  sortMode="single"
  [(selection)]="selectedRecords"
  dataKey="centroId"
  [paginator]="true"
  [rows]="20"
  [rowsPerPageOptions]="[10, 20, 50]"
  [sortField]="'centroId'"
  [sortOrder]="-1"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem" id="check-header"></th>

      <th pSortableColumn="centroId" id="code-header">
        {{ "WEB_RESULTS.CENTERS.ID" | translate }}
        <p-sortIcon field="centroId"></p-sortIcon>
      </th>
      <th pSortableColumn="centroName" id="name-header">
        {{ "WEB_RESULTS.CENTERS.NAME" | translate }}
        <p-sortIcon field="centroName"></p-sortIcon>
        <p-columnFilter
          type="text"
          field="centroName"
          matchMode="contains"
          display="menu"
          [showOperator]="false"
          [showAddButton]="false"
        ></p-columnFilter>
      </th>
      <th pSortableColumn="userCount" id="users-header">
        {{ "WEB_RESULTS.CENTERS.ASSIGNED_USERS" | translate }}
        <p-sortIcon field="userCount"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-record>
    <tr>
      <td>
        <div class="row-buttons">
          <p-tableCheckbox
            [value]="record"
            [disabled]="(record.userCount ?? 0) > 0"
          ></p-tableCheckbox>
          <button
            pButton
            pRipple
            type="button"
            icon="pi pi-pencil"
            (click)="onRowEdit(record)"
            class="p-button-rounded p-button-text"
          ></button>
        </div>
      </td>
      <td>{{ record.centroId }}</td>
      <td>{{ record.centroName }}</td>
      <td>{{ record.userCount ?? 0 }}</td>
    </tr>
  </ng-template>
</p-table>
